"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbUtils = void 0;
var DbUtils = /** @class */ (function () {
    function DbUtils() {
    }
    DbUtils.fetchSpec = function (items) {
        var spec = {};
        if (items && items.length === 1 && items[0].match(/^recursive:/)) {
            return items[0];
        }
        for (var i = 0; i < items.length; i++) {
            spec[items[i]] = (items[i + 1] instanceof Array) ? DbUtils.fetchSpec(items[++i]) : true;
        }
        return {
            fetch: spec
        };
    };
    DbUtils.buildFetchSpecArray = function (details, mapping) {
        var spec = [];
        Object.keys(details).forEach(function (key) {
            if (typeof details[key] === 'object') {
                var val = mapping[key];
                (val !== undefined) ? spec.push(val) : spec.push("".concat(key));
                var attributes = (details[key] instanceof Array) ? DbUtils.buildFetchSpecArray(details[key][0], mapping) : DbUtils.buildFetchSpecArray(details[key], mapping);
                if (attributes.length > 0) {
                    spec.push(attributes);
                }
            }
        });
        return spec;
    };
    DbUtils.buildFetchSpec = function (details, mapping) {
        return DbUtils.fetchSpec(DbUtils.buildFetchSpecArray(details, mapping));
    };
    return DbUtils;
}());
exports.DbUtils = DbUtils;
